<script>
import lazyLoadComponent from '@router/lazyload-component'
import { saveState, getSavedState } from '@utils/browser-help'
import pageMixin from '@src/mixins/pagination'
import incomeMixin from '@src/mixins/income'
import analyticsDateValidateMixin from '@src/mixins/analyticsDateValidateMixin'
import formatDate, { formatRequestData } from '@utils/format-date'
import { toThousands, formatSummaries } from '@utils/format-currency'

// import { inComeData } from './fakeData'

export default {
  page: {
    title: '數據分析',
    meta: [{ name: 'description', content: 'Customer Analytics' }],
  },
  components: {},
  mixins: [pageMixin, incomeMixin, analyticsDateValidateMixin],
  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
  },
  filters: {
    toThousands
  },
  data() {
    return {
      filterData: {
        startDate: '',
        endDate: '',
        unit: 'week',
        productId: '',
      },

      // inComeData,
      income: {},
      // sellData,
      // activeFilter: 'week',
      dateRangeMode: 'month',
      dateNow: '',
      activeCellData: '',
      tryingFetch: false,
      tryingFetchTime: false,
      tryingToExport: false,
      columnIncomeShowListVue: [
        {
          value: "salesFigures",
          name: "銷售總額"
        },
        {
          value: "refundTotal",
          name: "退款"
        },
        {
          value: "couponTotal",
          name: "優惠券"
        },
        {
          value: "netSales",
          name: "銷售淨額"
        },
        {
          value: "taxTotal",
          name: "稅金5%"
        },
        {
          value: "niat",
          name: "稅後淨額"
        },
        {
          value: "avgOrderPrice",
          name: "平均訂單銷售淨額"
        },
        {
          value: "avgOrderCount",
          name: "平均訂單數"
        },
      ],
      forShowColumnInSelect: [],
    }
  },
  computed: {
    columnIncomeShowListFromMixin() {
      return this.columnIncomeShowList.filter(item => {
        return item.value !== 'total' && item.value !== 'orders' && item.value !== 'depositTotal' && item.value !== 'prepaidTotal'
      })
    },
    columnShowListIncome() {
      let list = [...this.columnIncomeShowListVue, ...this.columnIncomeShowListFromMixin]
      // 如果沒有開通線上金流，則filter線上系列
      if (!this.$cashFlowSettingPass()) {
        list = list.filter(item => item.value !== 'creditTotal' && item.value !== 'vaccTotal')
      }
      // 自燃派才開放中租，其他店家filter中租
      if(this.$store.state.merchant.cached.alias !== 'naturalpan') {
        list = list.filter(item => item.value !== 'chaileaseTotal')
      }
      return list
    },
    filterDateRange: {
      get() {
        return [this.filterData.startDate, this.filterData.endDate]
      },
      set(value) {
        const [start, end] = value || ['', '']
        this.filterData.startDate = start
        this.filterData.endDate = end
      },
    },
    fetchDataParams() {
      const routeQuery = this.$route.query
      const queryData = Object.assign(routeQuery, this.pageQuery)
      const { startDate, endDate, ...filterDataWithoutDate } = this.filterData
      const searchWithDate = startDate && endDate
      const searchParams = searchWithDate
        ? Object.assign(this.filterData, {
          startDate: formatRequestData(startDate),
          endDate: formatRequestData(endDate),
        })
        : filterDataWithoutDate
      return Object.assign(searchParams, queryData)
    },
  },
  watch: {
    filterDateRange(value) {
      if (this.filterDateRange[0] === undefined) {
        this.dateRangeMode = ''
        return
      }
      const time = (new Date(this.filterDateRange[1]).getTime() / 1000 - new Date(this.filterDateRange[0]).getTime() / 1000) / 86400
      const todayRange = Math.floor(new Date().getTime() / 1000 / 86400) - new Date(this.filterDateRange[0]).getTime() / 1000 / 86400
      switch (true) {
        case time >= 0 && time <= 7:
          this.dateRangeMode = 'day'
          this.filterData.unit = 'day'
          break
        case time > 7 && time < 30:
          this.dateRangeMode = 'week'
          this.filterData.unit = 'day'
          break
        case time >= 30 && time < 364:
          this.dateRangeMode = 'month'
          this.filterData.unit = 'week'
          break
        case time >= 365:
          this.dateRangeMode = 'year'
          this.filterData.unit = 'quarter'
          break
      }
      switch (true) {
        case todayRange === 0:
          this.dateNow = 'day'
          break
        case todayRange === 30:
          this.dateNow = 'month'
          break
        default:
          this.dateNow = ''
      }
    },
  },
  created() {
    this.getDefaultDate()
    this.tryToFetchList()
    this.setAnaColumnList()
  },
  mounted() {
    let timeout = setInterval(() => {
      if (this.$refs['tableIncome'] !== undefined) {
        clearInterval(timeout)
        this.handleSynchronizeScroll(this.$refs.tableIncome)
      }
    }, 300)
  },
  methods: {
    handleSynchronizeScroll(el, bind = true) {
      let $body = el.$el.getElementsByClassName('el-table__body-wrapper')[0]
      let $scrollbar = el.$el.getElementsByClassName('el-table__footer-wrapper')[0]
      let $header = el.$el.getElementsByClassName('el-table__header-wrapper')[0]
      if (bind) {
        $header.addEventListener('scroll', () => {
          $body.scrollLeft = $header.scrollLeft
          $scrollbar.scrollLeft = $header.scrollLeft
        })
        $body.addEventListener('scroll', () => {
          $header.scrollLeft = $body.scrollLeft
          $scrollbar.scrollLeft = $body.scrollLeft
        })
        $scrollbar.addEventListener('scroll', () => {
          $header.scrollLeft = $scrollbar.scrollLeft
          $body.scrollLeft = $scrollbar.scrollLeft
        })
      } else {
        $header.removeEventListener('scroll', () => {
          $body.scrollLeft = $header.scrollLeft
          $scrollbar.scrollLeft = $header.scrollLeft
        })
        $body.removeEventListener('scroll', () => {
          $header.scrollLeft = $body.scrollLeft
          $scrollbar.scrollLeft = $body.scrollLeft
        })
        $scrollbar.removeEventListener('scroll', () => {
          $header.scrollLeft = $scrollbar.scrollLeft
          $body.scrollLeft = $scrollbar.scrollLeft
        })
      }
    },
    /**
     * @description 初始化要顯示的欄位
     */
    async setAnaColumnList() {
      const result = await getSavedState('anaColumnList')
      if (!result) return
      let key = this.columnShowListIncome.map(item => item.value)
      result.forEach(item => {
        if (key.includes(item)) {
          this.forShowColumnInSelect.push(item)
        }
      })
    },
    async anaColumnListSave() {
      await saveState('anaColumnList', this.forShowColumnInSelect)
    },
    formatSummaries,
    getDefaultDate() {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      this.filterData.startDate = `${start.getFullYear()}/${start.getMonth() + 1}/${start.getDate()}`
      this.filterData.endDate = `${end.getFullYear()}/${end.getMonth() + 1}/${end.getDate()}`
    },
    async tryToFetchList(isChangeTime) {
      this.tryingFetch = true
      this.tryingFetchTime = true
      this.income = await this.$store.dispatch('analytics/fetchIncome', this.fetchDataParams)
      for (let i = 0, len = this.income.table.length; i < len; i++) {
        this.$set(this.income.table[i], 'forShowAvgOrderCount', this.income.avgOrderCount)
      }
      this.tryingFetch = false
      this.tryingFetchTime = false
    },
    async tryToFetchListUnit() {
      this.tryingFetchTime = true
      this.income = await this.$store.dispatch('analytics/fetchIncome', this.fetchDataParams)
      this.tryingFetchTime = false
    },
    changeMode(valve) {
      this.dateRangeMode = valve
    },
    reset() {
      this.getDefaultDate()
      this.dateRangeMode = 'month'
      this.filterData.unit = 'week'
      this.tryToFetchList()
    },
    selectData(value) {
      this.activeCellData = value
      this.changeCellClass()
    },
    changeCellClass(row, column, rowIndex, columnIndex) {
      if (row && row.column.label === this.activeCellData) {
        return 'active'
      } else {
        return ''
      }
    },
    async handleExport() {
      if (this.tryingToExport) return
      this.tryingToExport = true
      const request = {
        analyticsType: 'income',
        submitData: {
          ...this.fetchDataParams,
          export: 1
        }
      }
      const { fileName, csvData } = await this.$store.dispatch('analytics/analyticsExport', request)
      const csvFormatData = csvData.map((row) => Object.values(row).join(',')).join('\n')
      const blob = new Blob(['\uFEFF', csvFormatData], {
        type: 'text/csv;charset=utf-8;',
      })

      const url = window.URL.createObjectURL(blob)
      const date = `${this.filterDateRange[0]} 至 ${this.filterDateRange[1]}`
      let productTitle = ''
      if (this.fetchDataParams.productId) {
        productTitle = this.merchantProducts.find((item) => {
          return item.id === this.fetchDataParams.productId
        }).name
        productTitle = ` ${productTitle}`
      }
      const filterFileName = `${fileName} ( ${date}${productTitle} ).csv`
      const tempLink = document.createElement('a')
      tempLink.download = filterFileName
      tempLink.href = url
      tempLink.click()
      window.URL.revokeObjectURL(url)
      this.tryingToExport = false
    },
    quickSelectTime(unit) {
      if (unit === 'day') {
        const end = new Date()
        const start = new Date()
        this.filterDateRange = [start, end]
      }
      if (unit === 'month') {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        this.filterDateRange = [start, end]
      }
      this.tryToFetchList()
    }
  },
}
</script>

<template>
  <div :class="$style.page">
    <div class="btn-top-space-between local_topBtn">
      <el-button class="is-round" plain @click="handleExport">
        <BaseIcon name="file-export" /> 訂單匯出
      </el-button>
    </div>
    <BaseTableSearch v-slot="{ fields }" :grow-status="true" :class="$style.filter" :default-value.sync="filterData"
      hide-action class="isForTab2" reset-btn-style="width:84px;height:44px;" @reset="reset" @handleExport="handleExport"
      @tryToFetchList="tryToFetchList">
      <el-form-item prop="status" class="w-full" style="width: 20%">
        <el-select v-model="fields.productId" placeholder="分店" @change="tryToFetchList">
          <el-option label="全部分店" value></el-option>
          <el-option v-for="(product, index) in merchantProducts" :key="index" :label="product.name"
            :value="product.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="status" class="w-full" style="width: 20%" :class="$style.columnShowList">
        <el-select v-model="forShowColumnInSelect" popper-class="isStylecColumnShowList" placeholder="欄位顯示" multiple
          @change="anaColumnListSave">
          <el-option label="欄位顯示" value disabled></el-option>
          <el-option v-for="(column, index) in columnShowListIncome" :key="index" :label="column.name"
            :value="column.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="width: 41%">
        <el-date-picker v-model="filterDateRange" type="daterange" align="right" unlink-panels range-separator="至"
          start-placeholder="起始日期" end-placeholder="結束日期" :picker-options="pickerOptions"
          @change="tryToFetchListFromDatePicker"></el-date-picker>
      </el-form-item>
    </BaseTableSearch>
    <!-- 中間銷售總額 -->
    <div v-loading="tryingFetch" class="infoBox" :class="$style.incomeBgColor">
      <transition name="el-fade-in-linear">
        <div v-if="forShowColumnInSelect.includes('salesFigures')" class="infoBox__item"
          :class="{ isActive: activeCellData === '銷售總額' }" @click="selectData('銷售總額')">
          <div class="infoBox__title"> 銷售總額
            <el-tooltip content="計算已付款和未付款訂單的售價金額。金額含稅、不含退款＆優惠" placement="right">
              <BaseIcon name="info-circle" />
            </el-tooltip>
          </div>
          <div class="infoBox__content"> NT${{ income.salesFigures | toThousands }} </div>
        </div>
      </transition>
      <transition name="el-fade-in-linear">
        <div v-if="forShowColumnInSelect.includes('refundTotal')" class="infoBox__item"
          :class="{ isActive: activeCellData === '退款' }" @click="selectData('退款')">
          <div class="infoBox__title"> 退款 </div>
          <div class="infoBox__content"> NT${{ income.refundTotal | toThousands }} </div>
        </div>
      </transition>
      <transition name="el-fade-in-linear">
        <div v-if="forShowColumnInSelect.includes('couponTotal')" class="infoBox__item"
          :class="{ isActive: activeCellData === '優惠券' }" @click="selectData('優惠券')">
          <div class="infoBox__title"> 優惠券 </div>
          <div class="infoBox__content"> NT${{ income.couponTotal | toThousands }} </div>
        </div>
      </transition>
      <transition name="el-fade-in-linear">
        <div v-if="forShowColumnInSelect.includes('netSales')" class="infoBox__item"
          :class="{ isActive: activeCellData === '銷售淨額' }" @click="selectData('銷售淨額')">
          <div class="infoBox__title"> 銷售淨額
            <el-tooltip content="扣掉退款、優惠後，即是現在訂單列表上的總金額。 銷售淨額 = 銷售總額 - 退款 - 優惠券金額" placement="right">
              <BaseIcon name="info-circle" />
            </el-tooltip>
          </div>

          <div class="infoBox__content"> NT${{ income.netSales | toThousands }} </div>
        </div>
      </transition>
      <transition name="el-fade-in-linear">
        <div v-if="forShowColumnInSelect.includes('taxTotal')" class="infoBox__item"
          :class="{ isActive: activeCellData === '稅金' }" @click="selectData('稅金')">
          <div class="infoBox__title"> 稅金5%
            <el-tooltip content="稅金= 銷售淨額 x 5%" placement="right">
              <BaseIcon name="info-circle" />
            </el-tooltip>
          </div>
          <div class="infoBox__content"> NT${{ income.taxTotal | toThousands }} </div>
        </div>
      </transition>
      <transition name="el-fade-in-linear">
        <div v-if="forShowColumnInSelect.includes('niat')" class="infoBox__item"
          :class="{ isActive: activeCellData === '稅後淨額' }" @click="selectData('稅後淨額')">
          <div class="infoBox__title"> 稅後淨額
            <el-tooltip content="稅後淨額 = 銷售淨額 - 稅金" placement="right">
              <BaseIcon name="info-circle" />
            </el-tooltip>
          </div>
          <div class="infoBox__content"> NT${{ income.niat | toThousands }} </div>
        </div>
      </transition>
      <transition name="el-fade-in-linear">
        <div v-if="forShowColumnInSelect.includes('avgOrderPrice')" class="infoBox__item"
          :class="{ isActive: activeCellData === '平均訂單銷售淨額' }" @click="selectData('平均訂單銷售淨額')">
          <div class="infoBox__title">
            平均訂單銷售淨額 <el-tooltip content="平均訂單銷售淨額 = 銷售淨額 / 訂單數" placement="right">
              <BaseIcon name="info-circle" />
            </el-tooltip>
          </div>
          <div class="infoBox__content"> NT${{ income.avgOrderPrice | toThousands }} </div>
        </div>
      </transition>
      <transition name="el-fade-in-linear">
        <div v-if="forShowColumnInSelect.includes('avgOrderCount')" class="infoBox__item"
          :class="{ isActive: activeCellData === '平均訂單數' }" @click="selectData('平均訂單數')">
          <div class="infoBox__title"> 平均訂單數 </div>
          <div class="infoBox__content">
            {{ income.avgOrderCount }}
          </div>
        </div>
      </transition>

      <transition name="el-fade-in-linear" v-for="item in columnIncomeShowListFromMixin" :key="item.value">
        <div v-if="forShowColumnInSelect.includes(item.value)" class="infoBox__item"
          :class="{ isActive: activeCellData === item.name }" @click="selectData(item.name)">
          <div class="infoBox__title"> {{ item.name }} </div>
          <div class="infoBox__content">
            NT$ {{ income[item.value] | toThousands }}
          </div>
        </div>
      </transition>

    </div>
    <!-- 日、周、月、季、年 -->
    <div class="centerTextRadio" :class="$style.incomeBgColor">
      <h4>收益紀錄</h4>
      <div class="right-radio">
        <el-radio-group v-model="filterData.unit" @change="tryToFetchListUnit">
          <el-radio-button label="day" :disabled="dateRangeMode === 'year' || dateRangeMode === 'month'">日
          </el-radio-button>
          <el-radio-button label="week" :disabled="dateRangeMode === 'year' || dateRangeMode === 'day'">週
          </el-radio-button>
          <el-radio-button label="month" :disabled="dateRangeMode === 'week' || dateRangeMode === 'day'">月
          </el-radio-button>
          <el-radio-button label="quarter" :disabled="dateRangeMode !== 'year' && dateRangeMode !== ''">季
          </el-radio-button>
          <el-radio-button label="year" :disabled="dateRangeMode !== 'year' && dateRangeMode !== ''">年</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="el-table-wrapper" style="padding: 0 20px 20px;" :class="$style.tableScrollBar">
      <el-table ref="tableIncome" v-loading="tryingFetchTime" show-summary :summary-method="formatSummaries" sum-text="總計"
        element-loading-text="取得資訊中" :data="income.table" :cell-class-name="changeCellClass"
        :header-cell-class-name="changeCellClass" style="width:100%">
        <el-table-column label="日期" prop="date" width="200"></el-table-column>
        <el-table-column label="訂單數" prop="ordersCount" align="right" min-width="80"> </el-table-column>
        <el-table-column v-if="forShowColumnInSelect.includes('salesFigures')" label="銷售總額" prop="salesFigures"
          align="right" min-width="110">
          <template slot="header">
            銷售總額 <el-tooltip content="計算已付款和未付款訂單的售價金額。金額含稅、不含退款＆優惠" placement="right">
              <BaseIcon name="info-circle" />
            </el-tooltip>
          </template>
          <template slot-scope="scope"> ${{ scope.row.salesFigures | toThousands }} </template>
        </el-table-column>
        <el-table-column v-if="forShowColumnInSelect.includes('refundTotal')" prop="refundTotal" label="退款" align="right"
          min-width="110">
          <template slot="header">退款</template>
          <template slot-scope="scope"> ${{ scope.row.refundTotal | toThousands }} </template>
        </el-table-column>
        <el-table-column v-if="forShowColumnInSelect.includes('couponTotal')" prop="couponTotal" label="優惠券" align="right"
          min-width="110">
          <template slot="header">優惠券</template>
          <template slot-scope="scope"> ${{ scope.row.couponTotal | toThousands }} </template>
        </el-table-column>
        <el-table-column v-if="forShowColumnInSelect.includes('netSales')" prop="netSales" label="銷售淨額" align="right"
          min-width="110">
          <template slot="header">
            銷售淨額
            <el-tooltip content="扣掉退款、優惠後，即是現在訂單列表上的總金額。
銷售淨額 = 銷售總額 - 退款 - 優惠券金額" placement="right">
              <BaseIcon name="info-circle" />
            </el-tooltip>
          </template>
          <template slot-scope="scope"> ${{ scope.row.netSales | toThousands }} </template>
        </el-table-column>
        <el-table-column v-if="forShowColumnInSelect.includes('taxTotal')" prop="taxTotal" label="稅金" align="right"
          min-width="110">
          <template slot="header">稅金5% <el-tooltip content="稅金= 銷售淨額 x 5%" placement="right">
              <BaseIcon name="info-circle" />
            </el-tooltip></template>
          <template slot-scope="scope"> ${{ scope.row.taxTotal | toThousands }} </template>
        </el-table-column>
        <el-table-column v-if="forShowColumnInSelect.includes('niat')" prop="niat" label="稅後淨額" align="right"
          min-width="110">
          <template slot="header">稅後淨額<el-tooltip content="稅後淨額 = 銷售淨額 - 稅金" placement="right">
              <BaseIcon name="info-circle" />
            </el-tooltip></template>
          <template slot-scope="scope"> ${{ scope.row.niat | toThousands }} </template>
        </el-table-column>
        <el-table-column v-if="forShowColumnInSelect.includes('avgOrderPrice')" prop="avgOrderPrice" label="平均訂單銷售淨額"
          align="right" min-width="150">
          <template slot="header">平均訂單銷售淨額</template>
          <template slot-scope="scope"> ${{ scope.row.avgOrderPrice | toThousands }} </template>
        </el-table-column>
        <el-table-column v-if="forShowColumnInSelect.includes('avgOrderCount')" prop="avgOrderCount" label="平均訂單數"
          align="right" min-width="110">
          <template slot="header">平均訂單數</template>
          <template slot-scope="scope"> {{ scope.row.avgOrderCount }} </template>
        </el-table-column>
        <template v-for="item in columnIncomeShowListFromMixin">
          <el-table-column v-if="forShowColumnInSelect.includes(item.value)" :key="item.value" :prop="item.value" :label="item.name"
            align="right" min-width="150">
            <template slot="header">{{ item.name }}</template>
            <template slot-scope="scope"> ${{ scope.row[item.value] | toThousands }} </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>
<style lang="scss" module>
.page {
  margin: 20px;
}

:global {
  :local(.filter) {
    &>div {

      // flex-wrap: wrap;
      .el-form-item {
        @include max-lg {
          width: 100% !important;
        }
      }

      &+button {
        align-self: baseline;
      }
    }
  }
}

.bottomInfo {
  text-align: center;
  padding: 30px 0;

  :global {
    .bottomInfo {
      &__item {
        padding: 0 10px;
      }
    }
  }
}

.incomeBgColor {
  background-color: white;
  margin-left: 0px;
  margin-right: 0px;
}

.tableScrollBar {
  :global {
    .el-table__footer-wrapper {
      // max-height: 50vh;
      overflow-x: auto;

      // 整體位置
      &::-webkit-scrollbar {
        display: block;
        height: 10px;
      }

      // 底層顏色
      &::-webkit-scrollbar-track {
        // border-radius: 10px;
      }

      // 可移動的那條
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #d8d8d8;
      }
    }
  }

  // :global {
  //   .el-table__body-wrapper {
  //     background-color: red;
  //     &::-webkit-scrollbar{
  //     height: 4px;
  //     }
  //   }
  // }
  // overflow: overlay;
  // :global {
  //   .el-scrollbar__bar.is-horizontal {
  //     width: 100%;
  //     .el-scrollbar__thumb {
  //       border-radius: 10px;
  //         background-color: red;
  //         width: 100px;
  //     }
  //   }
  // }
}

.local_topBtn {
  background-color: $color-body-bg;
  padding-bottom: 18px;
  justify-content: end;
}

.columnShowList {
  :global {
    .el-select__tags {
      padding-left: 1px;
      padding-right: 6px;

      span {
        display: flex;
        overflow-x: scroll;

        span {
          flex-shrink: 0;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>
